/**
 * Claims the caller's in-progress CCPro call for the Live Services agent picking
 * it up, so `Call.Agent` reflects that agent even when a VA or another agent
 * answered first.
 *
 * Fire-and-forget. Behind featureLiveServicesCallClaim, this replaces the
 * Phone/CallBubbleDetect hidden-iframe hit in openLiveServicesCallBubble rather
 * than running alongside it. Failure is left to the caller to log.
 *
 * There is no agent-identity argument on purpose: the monolith resolves the
 * agent from the forwarded user token, so a client cannot claim a call on
 * someone else's behalf.
 */
import { getClient } from '@api/client';
import { graphql } from '@api/generated';
import { ClaimLiveServicesCallMutationVariables } from '@api/generated/graphql';

export const CLAIM_LIVE_SERVICES_CALL_MUTATION = graphql(`
  mutation ClaimLiveServicesCall($tenantId: ID!, $callerPhoneNumber: String!) {
    claimLiveServicesCall(
      tenantId: $tenantId
      callerPhoneNumber: $callerPhoneNumber
    ) {
      outcome
      callId
    }
  }
`);

export const claimLiveServicesCall = async (
  variables: ClaimLiveServicesCallMutationVariables,
) => {
  const { data } = await getClient().mutate({
    mutation: CLAIM_LIVE_SERVICES_CALL_MUTATION,
    variables,
  });

  return data?.claimLiveServicesCall ?? null;
};
